import { trpc } from 'api'

import useSession, { useStore } from './useSession'
import { Customer } from '@ca/common/types'
import { useActiveDeal } from '@order/hooks/useDeal'
import { captureException } from '@sentry/react-native'
import { QuickLoginCreate } from '@ca/api/db/utils/QuickLogin'
import { useCallback } from 'react'

// type QuickLoginState = {
//   customer: Customer | undefined
//   strategy: VerifyStrategyType | undefined
// }

// type QuickLoginActions = {
//   setCustomer: (customer: Customer | undefined) => void
//   setStrategy: (strategy: VerifyStrategyType | undefined) => void
//   reset: () => void
// }

// const useQuickLogin = create<
//   QuickLoginState & QuickLoginActions,
//   [['zustand/persist', QuickLoginState]]
// >(
//   persist(
//     (set) => ({
//       customer: undefined,
//       strategy: undefined,
//       setCustomer: (customer) => set({ customer }),
//       setStrategy: (strategy) => set({ strategy }),
//       reset: () => set({ customer: undefined, strategy: undefined }),
//     }),
//     {
//       name: 'quick-login',
//       storage: createJSONStorage(() => stateStorage),
//     }
//   )
// )

const useQuickLogin = () => {
  const store = useStore()
  const save = trpc.customer.quickLogin.save.useMutation({
    onError: (err, req) => {
      console.error(err)
      captureException(err, {
        tags: {
          location: 'useQuickLogin',
        },
        extra: {
          request: req,
        },
      })
    },
  })
  const remove = trpc.customer.quickLogin.remove.useMutation()
  const activeDeal = useActiveDeal()

  const info = useSession((s) => s.info)

  const saveCustomer = useCallback(
    async (customer?: Customer) => {
      if (!customer || !store) {
        return
      }
      const req = {
        customer_id: `${customer.id}`,
        store_id: `${store.id}`,
        customer_data: {
          ...customer,
          info,
        },
        deal_id: activeDeal?.id ? `${activeDeal.id}` : undefined,
      } satisfies QuickLoginCreate
      try {
        await save.mutateAsync(req)
      } catch (e) {
        console.error(e)
        captureException(e, {
          tags: {
            location: 'useQuickLogin',
          },
          extra: {
            request: req,
          },
        })
      }
    },
    [store, activeDeal, info, save]
  )

  const removeCustomer = useCallback(
    async (customerId: string) => {
      if (!store) {
        return
      }
      await remove.mutateAsync({
        customer_id: customerId,
        store_id: `${store.id}`,
      })
    },
    [remove, store]
  )

  return { saveCustomer, removeCustomer }
}

export default useQuickLogin
